import { Grid, GridProps } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import {
  SearchableSelect,
  SearchableSelectProps
} from '../../../../../atomic/input/searchableSelect';
import { FormFieldWrapper } from '../../shared/formFieldWrapper';
import { FormFieldProps } from '../index';

export type FormSearchableSelectProps = FormFieldProps &
  Omit<SearchableSelectProps, 'onChange' | 'helperText'> &
  Pick<GridProps, 'lg' | 'md' | 'sm' | 'xl' | 'xs'>;

export const FormSearchableSelect = FormFieldWrapper<FormSearchableSelectProps>((props) => {
  const [field, meta] = useField<string | number>({
    name: props.name
  });
  const { setFieldValue } = useFormikContext();

  return (
    <Grid item xs={props.xs ?? 12} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl}>
      <SearchableSelect
        {...props}
        label={props.label}
        value={field.value}
        onChange={(option) => {
          setFieldValue(field.name, option);
          props.additionalOnChange?.(option, setFieldValue);
        }}
        onBlur={field.onBlur}
        error={meta.touched && Boolean(meta.error)}
        helperText={meta.error}
        options={props.options}
        required={props.required}
      />
    </Grid>
  );
});
